<template>
    <div id="tables-list">
        <div class="panel panel-default">
            <div class="panel-heading">
                <input class="form-control" type="text"
                v-model="filter" placeholder="Search...">
            </div>
        </div>
        <div class="panel-group scrollable" id="accordion" role="tablist">
            <version-item
            v-for="table in tables"
            :table="table"
            :useCart="useCart"
            :key="table">
        </version-item>
    </div>
</div>
</template>


<script type="text/javascript">
    import VersionItem from './VersionItem.vue'

    export default {
        props: ['useCart'],
        data(){
            return {
                filter: ''
            }
        },
        components: {
            'version-item': VersionItem
        },
        computed: {
            tables(){
                var tables = this.$store.state.basket.tables
                //the slice is to limit rendering results to max 30 on the webpage (should improve performance)
                if (!this.filter){
                    tables = tables.slice(0,30);
                    return tables;
                } else {
                    return _.filter(tables, (table)=>{
                        return (table.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0);
                    }).slice(0,30);
                }

            }
        },
        mounted() {
            this.$store.dispatch('fetchTables')
        }
    }

</script>
<style type="text/css">

.scrollable {
    overflow-y: auto;
    overflow-x: hidden;
    height: 75vh;
}

</style>
